"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataValue = dataValue;
function _dataValue(data, path, pindex, schema) {
    const prop = path[pindex];
    if (prop === '') {
        if (pindex === path.length - 1) {
            return undefined;
        }
        else {
            return _dataValue(data, path, pindex + 1, schema);
        }
    }
    if (schema) {
        if (schema.type === 'object' && schema.properties) {
            const schitem = schema.properties[prop];
            if (schitem === undefined) {
                return undefined;
            }
            let ndata = data[prop];
            if (ndata === undefined) {
                if (schitem.default !== undefined) {
                    ndata = schitem.default;
                }
                else {
                    return undefined;
                }
            }
            if (pindex === path.length - 1) {
                return ndata;
            }
            else {
                return _dataValue(ndata, path, pindex + 1, schitem);
            }
        }
        else if (schema.type === 'array') {
            const schitem = schema.items;
            if (schitem === undefined) {
                return undefined;
            }
            let ndata = data[Number(prop)];
            if (ndata === undefined) {
                if (schitem.default !== undefined) {
                    ndata = schitem.default;
                }
                else {
                    return undefined;
                }
            }
            if (pindex === path.length - 1) {
                return ndata;
            }
            else {
                return _dataValue(ndata, path, pindex + 1, schitem);
            }
        }
        else {
            return undefined;
        }
    }
}
function dataValue(schema, data, path) {
    const tpath = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '')
        .split('.');
    return _dataValue(data, tpath, 0, schema);
}
exports.default = dataValue;
//# sourceMappingURL=dataValue.js.map